import type { TourDefinition } from './types'
import { COACH_TOUR } from './coachTour'
import { TRAINEE_SOLO_TOUR } from './traineeSoloTour'
import { TRAINEE_WITH_COACH_TOUR } from './traineeWithCoachTour'
import {
  TRAINING_SET_DETAIL_COACH_TOUR,
  TRAINING_SET_DETAIL_TRAINEE_TOUR,
} from './trainingSetDetailTour'

/** All registered TMA tours. Order matters for autoStart (first match wins). */
export const TOUR_REGISTRY: Record<string, TourDefinition> = {
  [COACH_TOUR.id]: COACH_TOUR,
  [TRAINEE_SOLO_TOUR.id]: TRAINEE_SOLO_TOUR,
  [TRAINEE_WITH_COACH_TOUR.id]: TRAINEE_WITH_COACH_TOUR,
  [TRAINING_SET_DETAIL_COACH_TOUR.id]: TRAINING_SET_DETAIL_COACH_TOUR,
  [TRAINING_SET_DETAIL_TRAINEE_TOUR.id]: TRAINING_SET_DETAIL_TRAINEE_TOUR,
}

export function getTour(tourId: string): TourDefinition | undefined {
  return TOUR_REGISTRY[tourId]
}

export function listTours(): TourDefinition[] {
  return Object.values(TOUR_REGISTRY)
}
